import { useToastStore } from '../index';
import { type ToastTone } from '../index';
import { Icon } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';

const TONE_VAR: Record<ToastTone, string> = {
  ok: 'var(--ok)',
  att: 'var(--att)',
  crit: 'var(--crit)',
  info: 'var(--sel)',
};

/** Bottom right, one at a time; red toasts stay until dismissed (rule 16). */
export function Toasts() {
  const { t } = useTranslation();
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);
  return (
    <div className="toasts" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={['toast', toast.tone === 'crit' ? 'crit' : ''].join(' ').trim()}
          role={toast.tone === 'crit' ? 'alert' : 'status'}
        >
          <span className="dot" style={{ marginTop: 5, background: TONE_VAR[toast.tone] }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <p className="tt">{toast.title}</p>
            {toast.detail === undefined ? null : <p className="ts">{toast.detail}</p>}
          </div>
          <button
            type="button"
            className="btn ico ghost x"
            onClick={() => dismiss(toast.id)}
            aria-label={t('common.actions.close')}
          >
            <Icon name="close" size={13} />
          </button>
        </div>
      ))}
    </div>
  );
}
